import { EDITOR_ROUTE_PATH } from 'app/beta-editor/constants';

const routes = {
  [`/${EDITOR_ROUTE_PATH}`]: {
    fetch: () =>
      import(
        /* webpackChunkName: 'editor-route' */ 'app/editor/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
